import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicSessionOrganizationGroupNamePipe } from 'ZalamoLibrary/src/lib/zalamo/pipes/public-session-organization-group-name/public-session-organization-group-name.pipe';

@NgModule({
  declarations: [PublicSessionOrganizationGroupNamePipe],
  exports: [PublicSessionOrganizationGroupNamePipe],
  imports: [CommonModule],
})
export class PublicSessionOrganizationGroupNameModule {}
